import React, { useRef, useEffect } from 'react';
import cn from 'classnames';
import MobileNavItem from './MobileNavItem';
import LangSwitcher from '../../../LangSwitcher/LangSwitcher';
import { searchStore as store } from 'store';
import { itemWrapper, panelItem, switcher, animate } from './MobileNavPanel.module.scss';

export default function MobileNavPanel({
  className,
  active,
  parent,
  items,
  isIndexPage,
  enableSwitcher,
  setNextActivePanel,
  open,
  searchActive,
}) {
  const itemRef = useRef(null);

  const calculateMobileSearchCoordinates = () => {
    if (open && active && !searchActive) {
      const rect = itemRef.current.getBoundingClientRect();
      const preparedRectPayload = {
        left: `${rect.left}px`,
        right: `${rect.right - rect.width}px`,
      };
      store.setMobileSearchCoordinates(preparedRectPayload);
    }
  };

  useEffect(() => {
    if (open && itemRef.current) {
      calculateMobileSearchCoordinates();
    }
  }, [open]);

  useEffect(() => {
    if (itemRef.current) {
      window.addEventListener('resize', calculateMobileSearchCoordinates);

      return () => {
        window.removeEventListener('resize', calculateMobileSearchCoordinates);
      };
    }
  }, [active, searchActive, open, itemRef.current]);

  return (
    <>
      <div className={cn(itemWrapper, className)} ref={itemRef}>
        {items.map((item, i) => (
          <MobileNavItem
            key={`${item.title}-${i}`}
            {...item}
            onClick={() => setNextActivePanel({ previous: parent, current: item.title })}
            style={{ '--item-number': i }}
            className={cn(panelItem, open ? animate : undefined)}
          />
        ))}
        {enableSwitcher && !parent && (
          <LangSwitcher
            isIndexPage={isIndexPage}
            className={cn(panelItem, switcher, open ? animate : undefined)}
          />
        )}
      </div>
    </>
  );
}
